export default "__VITE_ASSET__Be6jt1vB__"